var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dense":"","color":"secondary"}},[_c('h3',{staticClass:"goldman-font ml-1"},[_vm._v(_vm._s(_vm.$route.params.id))]),_c('v-spacer'),_c('AdminModel',{attrs:{"admin":_vm.validateAdmin}}),_c('StatusModel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }